import styled from 'styled-components'

import type { TypographyProps } from 'src/styles/typography/typography'
import { fontMixin } from 'src/styles/typography/typography'

interface Props {
  toggled: boolean
}

type ThemedToggleIconBaseProps = TypographyProps & Props

export const ToggleIconBase = styled.div<ThemedToggleIconBaseProps>`
  ${props =>
    fontMixin({
      ...props,
      color: props.color || 'grey2',
      size: props.size || 's',
      fontFamily: props.fontFamily || 'primary',
    })};
  margin-block: 0.25rem;
  margin-inline: 0.25rem;
  padding-block: 10px;
  padding-inline: 16px;
  max-width: 100%;
  width: max-content;
  background-color: ${({ theme, toggled }) => (toggled ? theme.colors.grey2 : theme.colors.grey8)};
  border: 2px solid ${({ theme, toggled }) => (toggled ? theme.colors.grey2 : theme.colors.grey5)};
  border-radius: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  cursor: pointer;
  transition: 0.2s all;
  gap: 10px;

  &:hover {
    border: 2px solid ${({ theme, toggled }) => (toggled ? theme.colors.grey3 : theme.colors.grey2)};
    background-color: ${({ theme, toggled }) =>
      toggled ? theme.colors.grey3 : theme.colors.grey8};
  }

  svg {
    fill: ${({ theme, color }) => theme.colors[(color || 'grey2') as keyof typeof theme.colors]};
  }
`
